var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _rect8, _path2, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _circle0, _circle1, _circle10, _rect33, _rect34, _circle11, _circle12, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHintIcon500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 888 710.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #e4ecf4;\n      }\n\n      .st2 {\n        fill: #00263c;\n      }\n\n      .st3 {\n        fill: #f95744;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.9,604.8c-143.6,0-260.1-116.4-260.1-260.1,0-143.6,116.4-260.1,260.1-260.1,143.6,0,260.1,116.4,260.1,260.1,0,69-27.4,135.1-76.2,183.9-48.7,48.9-114.9,76.4-183.9,76.2ZM444.9,86.7c-142.3,0-258.1,115.8-258.1,258.1s115.8,258.1,258.1,258.1,258.1-115.8,258.1-258.1S587.2,86.7,444.9,86.7h0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 346.5,
    y: 381.8,
    width: 195,
    height: 262
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 313,
    y: 373.8,
    width: 262,
    height: 104
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 313,
    y: 489.8,
    width: 262,
    height: 104
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 313,
    y: 605.8,
    width: 262,
    height: 104
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 313,
    y: 417.9,
    width: 262,
    height: 16
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 313,
    y: 533.9,
    width: 262,
    height: 16
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 313,
    y: 649.9,
    width: 262,
    height: 16
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 524,
    cy: 388.8,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 545,
    cy: 388.8,
    r: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 566,
    cy: 388.8,
    r: 6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 524,
    cy: 502.8,
    r: 6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 545,
    cy: 502.8,
    r: 6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 566,
    cy: 502.8,
    r: 6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 524,
    cy: 616.8,
    r: 6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 545,
    cy: 616.8,
    r: 6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 566,
    cy: 616.8,
    r: 6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    y: 708.8,
    width: 888,
    height: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.9,271.1v186c0,8.1-6.6,14.7-14.7,14.7h-72.3c-8.1,0-14.7-6.6-14.7-14.7v-186c0-8.1,6.6-14.7,14.7-14.7h8.8c-1.5,3.6.3,7.6,3.8,9.1.8.3,1.7.5,2.6.5h41.2c3.9,0,7-3.1,7-7,0-.9-.2-1.8-.5-2.6h9.4c8.1,0,14.7,6.6,14.7,14.7Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 145.1,
    y: 291.9,
    width: 92,
    height: 128
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 171.2,
    y: 379.9,
    width: 36.7,
    height: 2.1
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 171.1,
    y: 387.6,
    width: 56.8,
    height: 2.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 171.1,
    y: 394.9,
    width: 44.6,
    height: 2.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 171.1,
    y: 402.1,
    width: 26.2,
    height: 2.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 171.1,
    y: 409.4,
    width: 39.3,
    height: 2.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 154.5,
    y: 379.3,
    width: 4.2,
    height: 4.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 154.5,
    y: 386.6,
    width: 4.2,
    height: 4.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 154.5,
    y: 393.8,
    width: 4.2,
    height: 4.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 154.5,
    y: 401.1,
    width: 4.2,
    height: 4.2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 154.5,
    y: 408.4,
    width: 4.2,
    height: 4.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 172.8,
    y: 307.9,
    width: 37,
    height: 37
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 321.1,
    y: 0.1,
    width: 245.9,
    height: 157.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 339.6,
    y: 44.2,
    width: 203.9,
    height: 77
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 376.8,
    y: 57.5,
    width: 48.9,
    height: 2.8
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 376.7,
    y: 67.8,
    width: 75.7,
    height: 2.8
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 376.7,
    y: 77.5,
    width: 59.4,
    height: 2.8
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 376.7,
    y: 87.2,
    width: 34.9,
    height: 2.8
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 376.7,
    y: 96.8,
    width: 52.4,
    height: 2.8
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 354.6,
    y: 56.7,
    width: 5.6,
    height: 5.6
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 354.6,
    y: 66.4,
    width: 5.6,
    height: 5.6
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 354.6,
    y: 76.1,
    width: 5.6,
    height: 5.6
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 354.6,
    y: 85.8,
    width: 5.6,
    height: 5.6
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 354.6,
    y: 95.4,
    width: 5.6,
    height: 5.6
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 483.4,
    y: 53.8,
    width: 50.1,
    height: 50.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 321,
    width: 245.9,
    height: 10.4
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 328.8,
    cy: 5.3,
    r: 2.1
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 336.1,
    cy: 5.3,
    r: 2.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 343.5,
    cy: 5.3,
    r: 2.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 671.6,
    y: 294.8,
    width: 60,
    height: 31
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 671.6,
    y: 405.8,
    width: 60,
    height: 31
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 701.6,
    cy: 365.8,
    r: 50
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 701.6,
    cy: 365.8,
    r: 39
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 688.9,
    y: 355.1,
    width: 30.2,
    height: 1.7
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 688.8,
    y: 361.5,
    width: 46.8,
    height: 1.7
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 688.8,
    y: 367.4,
    width: 36.7,
    height: 1.7
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 688.8,
    y: 373.4,
    width: 21.6,
    height: 1.7
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 688.8,
    y: 379.4,
    width: 32.4,
    height: 1.7
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 675.2,
    y: 354.6,
    width: 3.5,
    height: 3.5
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 675.2,
    y: 360.6,
    width: 3.5,
    height: 3.5
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 675.2,
    y: 366.6,
    width: 3.5,
    height: 3.5
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 675.2,
    y: 372.6,
    width: 3.5,
    height: 3.5
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 675.2,
    y: 378.5,
    width: 3.5,
    height: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintIcon500);
export default __webpack_public_path__ + "static/media/hintIcon-500.374f9df286e8eca3a7a22a753dfbb398.svg";
export { ForwardRef as ReactComponent };